import { useEffect } from 'react';
import { ANALYTICS_CONSENT_COOKIE } from 'shared/consent/cookies';
import { readJSONFromLocalStorage, writeJSONToLocalStorage } from 'shared/consent/localStorage';

export const EXPERIMENT_VARIANT_STORAGE_KEY = 'fhh_tjvr_experiment_variants';

type StoredExperiment = {
    variant: string;
    expiresAt: number;
};

type StoredExperiments = { [experimentName: string]: StoredExperiment };

const readStoredExperiments = (): StoredExperiments =>
    readJSONFromLocalStorage<StoredExperiments>(EXPERIMENT_VARIANT_STORAGE_KEY, ANALYTICS_CONSENT_COOKIE) ?? {};

const removeExpired = (stored: StoredExperiments): StoredExperiments => {
    const now = Date.now();
    const active: StoredExperiments = {};
    for (const [name, entry] of Object.entries(stored)) {
        if (entry.expiresAt > now) {
            active[name] = entry;
        }
    }
    return active;
};

export const useStoreExperimentVariant = (experimentName: string, variant: string | null | undefined, ttlMinutes: number) => {
    useEffect(() => {
        if (variant) {
            const stored = removeExpired(readStoredExperiments());
            stored[experimentName] = {
                variant,
                expiresAt: Date.now() + ttlMinutes * 60 * 1000,
            };
            writeJSONToLocalStorage(EXPERIMENT_VARIANT_STORAGE_KEY, stored, ANALYTICS_CONSENT_COOKIE);
        }
    }, [experimentName, variant, ttlMinutes]);
};

export const getActiveExperimentVariants = (): string | null => {
    const stored = removeExpired(readStoredExperiments());
    const entries = Object.entries(stored);
    if (entries.length === 0) return null;
    return entries.map(([name, { variant }]) => `${name}:${variant}`).join(',');
};

export const adjustUnleashVariant = (variant: string | undefined): string | undefined => (variant === 'disabled' ? undefined : variant);
